/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './NlpPropertySearchService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchProperties
 */
export const SEARCH_PROPERTIES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'searchProperties',
  args: ['input', 'resultLimit', 'requesterName', 'correlationId', 'similarityThreshold', 'propertySearchFilters', 'returnDefaultsForEmptyInput'],
  fetcher(request, ctx) {
    return chirpClient.call(References.searchPropertiesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchPropertiesWithPaging
 */
export const SEARCH_PROPERTIES_WITH_PAGING_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'searchPropertiesWithPaging',
  args: ['input', 'requesterName', 'correlationId', 'similarityThreshold', 'propertySearchFilters', 'checkFieldLevelPermissions', 'resultLimit', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    return chirpClient.call(References.searchPropertiesWithPagingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchPropertiesWithRankingData
 */
export const SEARCH_PROPERTIES_WITH_RANKING_DATA_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'searchPropertiesWithRankingData',
  args: ['input', 'resultLimit', 'requesterName', 'correlationId', 'similarityThreshold', 'propertySearchFilters', 'returnDefaultsForEmptyInput'],
  fetcher(request, ctx) {
    return chirpClient.call(References.searchPropertiesWithRankingDataRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchPropertiesReranked
 */
export const SEARCH_PROPERTIES_RERANKED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'searchPropertiesReranked',
  args: ['propertySearchRequest', 'thresholdRuleDefinitions', 'numberOfRerankingCandidates'],
  fetcher(request, ctx) {
    return chirpClient.call(References.searchPropertiesRerankedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchProperty
 */
export const SEARCH_PROPERTY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'searchProperty',
  args: ['objectTypeId', 'guessedProperty', 'requesterName', 'correlationId', 'similarityThreshold', 'propertySearchFilters', 'returnDefaultsForEmptyInput'],
  fetcher(request, ctx) {
    return chirpClient.call(References.searchPropertyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchPropertyWithValues
 */
export const SEARCH_PROPERTY_WITH_VALUES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'searchPropertyWithValues',
  args: ['guessedProperty', 'guessedValue', 'requesterName', 'correlationId', 'propertySearchFilters'],
  fetcher(request, ctx) {
    return chirpClient.call(References.searchPropertyWithValuesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#recordPropertyClickedEvent
 */
export const RECORD_PROPERTY_CLICKED_EVENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'recordPropertyClickedEvent',
  args: ['input', 'servedResponseResults', 'clickedResult', 'correlationId', 'requesterName', 'similarityThreshold', 'propertySearchFilters'],
  fetcher(request, ctx) {
    return chirpClient.call(References.recordPropertyClickedEventRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});